import { render } from "./CommentCol.vue?vue&type=template&id=3c2ab204&scoped=true"
import script from "./CommentCol.vue?vue&type=script&lang=js"
export * from "./CommentCol.vue?vue&type=script&lang=js"

import "./CommentCol.vue?vue&type=style&index=0&id=3c2ab204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2ab204"]])

export default __exports__